import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ResponseData } from '../interfaces/response.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class SlackApi extends BaseApi {
  /**
   * 用戶點擊LiveChat初始化訊息
   *
   * @returns boolean
   */
  liveChatInit(): Observable<boolean> {
    const url = `${environment.apiUrl}/v1/behavior/slack/livechatinit`;
    return this.post<ResponseData<boolean>>(url).pipe(map(x => x?.data));
  }
}
